module.exports = __webpack_public_path__ + "img/equipos-moviles-img-8.49d7d32a.jpg";